module.exports = __webpack_public_path__ + "img/selectedBg.5fbbc549.svg";